import { render, staticRenderFns } from "./leaveCompany.vue?vue&type=template&id=74b257bf&scoped=true"
import script from "./leaveCompany.vue?vue&type=script&lang=js"
export * from "./leaveCompany.vue?vue&type=script&lang=js"
import style0 from "./leaveCompany.vue?vue&type=style&index=0&id=74b257bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b257bf",
  null
  
)

export default component.exports